import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Categories from "@/components/Categories";
import Standards from "@/components/Standards";
import Featured from "@/components/Featured";
import Compare from "@/components/Compare";
import Dealer from "@/components/Dealer";
import Footer from "@/components/Footer";
import { scrollToId } from "@/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    document.title = "CHWA — Built for Work.";
  }, []);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => scrollToId(target), 450);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <>
      <Nav />
      <main>
        <Hero onExplore={() => scrollToId("#featured")} onDealer={() => scrollToId("#dealer")} />
        <Marquee />
        <Story />
        <Categories />
        <Standards />
        <Featured onDealer={() => scrollToId("#dealer")} />
        <Compare />
        <Dealer />
      </main>
      <Footer />
    </>
  );
}
